import {
  medigi,
  chimera,
  supplier1,
  supplier2,
  supplier3,
  supplier4,
  hikmav2,
  hikma,
  ipsen,
  ipsenProd,
  benevDemo,
  benevStaging,
  benevProduction,
  dysportdirect,
  eschelon,
  medigiStaging,
  gprStaging,
  gprDemo,
  gprProduction,
  localhost
} from 'src/environments/hydra/configs';

export const hydraSupplierConfigMap = {
  'localhost:4200': localhost,
  'localhost:4201': localhost,
  'www.medigi.com': medigi,
  'chimera.medigi.com': chimera,
  'medigi-staging.medigi.com': medigiStaging,
  'medigi-uat.medigi.com': medigiStaging,
  'medigi-demo.medigi.com': medigiStaging,
  'eschelon.medigi.com': eschelon,
  'supplier1.hydra.medigi.com': supplier1,
  'supplier2.hydra.medigi.com': supplier2,
  'supplier3.hydra.medigi.com': supplier3,
  'supplier4.hydra.medigi.com': supplier4,
  'hikmav2-staging.medigi.com': hikmav2,
  'hikma-production.medigi.com': hikma,
  'www.hikmadirect.com': hikma,
  'hikma-demo.medigi.com': hikma,
  'benev-staging.medigi.com': benevStaging,
  'gpr-staging.medigi.com': gprStaging,
  'benev-demo.medigi.com': benevDemo,
  'letybousa.medigi.com': benevProduction,
  'shop.letybousa.com': benevProduction,
  'letybousa-demo.medigi.com': benevDemo,
  'ipsen-staging.medigi.com': ipsen,
  'ipsen-demo.medigi.com': ipsen,
  'ipsen-production.medigi.com': ipsenProd,

  'supplier1.hydrademo.medigi.com': supplier1,
  'supplier2.hydrademo.medigi.com': supplier2,
  'supplier3.hydrademo.medigi.com': supplier3,
  'supplier4.hydrademo.medigi.com': supplier4,

  'dysportdirect.medigi.com': dysportdirect,
  'dysportdirect.com': dysportdirect,
  'www.dysportdirect.com': dysportdirect,
  'hikmadirect.com': hikma,
  'gpr-demo.medigi.com': gprDemo,
  'gpr-production.medigi.com': gprProduction,
  'order.pharmacyreserve.com': gprProduction
};
